export default __webpack_public_path__ + "static/media/jennie2.4276e325.gif";